export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#E37222',
    light: '#159095',
    after: '#6B5A9A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FFFFFF',
    light: '#FFFFFF33',
    contrastText: '#22211F',
  },
  text: {
    brand: '#00579C',
    primary: '#011C32',
    secondary: '#3E444E',
    tertiaryLight: '#626D7C',
    tertiary: '#0F0F0F',
    alternate: '#1F3B61',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    footerbg:'#25272C',
    link:'#21A8FF',
    howsubtitle:'#7C8694',
    black:'#000000',
    benefitssubtitle:'#49515B'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    brandLight: '#003964',
    fill: '#F6FCFC',
    hero1: '#002015B2',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#4E4E4E',
    footer: '#011A30',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#0E7389',
    tableSubhead: '#EEFDFD',
    tableBorder: '#BCC2CC',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#F7F8F8',
    secondary: '#F5F3F0',
    light: '#FAFAFA',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#D7DBE0',
    offer: '#CCEDFC',
    stepperCompleted: '#081425',
    benefits:'#F4F7FB',
    stepcounter:'#0371F2',
    pricingbenefits:'#0E7389',
    footerbackground:'#225C68',
    loginhome:'#F8F8F8'
  },
  surface: {
    light: '#B6BFA5',
    grey: '#FAFAFA',
    pricing: '#CCEDFC',
    learnMore: '#F4F4F4',
    header: '#EBF6FF',
    planCard: '#F7F8F8',
    switch: '#CFD1D1',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
